var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4993 1.66602V9.99935C12.4993 10.916 11.7493 11.666 10.8327 11.666H1.66602V6.34934C2.27435 7.07434 3.2077 7.52435 4.24104 7.49935C5.0827 7.48268 5.84102 7.15768 6.40768 6.61602C6.66602 6.39935 6.8827 6.12434 7.04937 5.82434C7.34937 5.31601 7.51602 4.71599 7.49935 4.09099C7.47435 3.11599 7.04103 2.25768 6.36603 1.66602H12.4993Z",
    stroke: "#00C12B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 11.666V14.166C18.3327 15.5493 17.216 16.666 15.8327 16.666H14.9993C14.9993 15.7493 14.2493 14.9993 13.3327 14.9993C12.416 14.9993 11.666 15.7493 11.666 16.666H8.33268C8.33268 15.7493 7.58268 14.9993 6.66602 14.9993C5.74935 14.9993 4.99935 15.7493 4.99935 16.666H4.16602C2.78268 16.666 1.66602 15.5493 1.66602 14.166V11.666H10.8327C11.7493 11.666 12.4993 10.916 12.4993 9.99935V4.16602H14.0327C14.6327 4.16602 15.1827 4.49102 15.4827 5.00769L16.9077 7.49935H15.8327C15.3743 7.49935 14.9993 7.87435 14.9993 8.33268V10.8327C14.9993 11.291 15.3743 11.666 15.8327 11.666H18.3327Z",
    stroke: "#00C12B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 18.3333C7.58714 18.3333 8.33333 17.5871 8.33333 16.6667C8.33333 15.7462 7.58714 15 6.66667 15C5.74619 15 5 15.7462 5 16.6667C5 17.5871 5.74619 18.3333 6.66667 18.3333Z",
    stroke: "#00C12B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 18.3333C14.2532 18.3333 14.9993 17.5871 14.9993 16.6667C14.9993 15.7462 14.2532 15 13.3327 15C12.4122 15 11.666 15.7462 11.666 16.6667C11.666 17.5871 12.4122 18.3333 13.3327 18.3333Z",
    stroke: "#B3B3B3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 10V11.6667H15.8333C15.375 11.6667 15 11.2917 15 10.8333V8.33333C15 7.875 15.375 7.5 15.8333 7.5H16.9083L18.3333 10Z",
    stroke: "#00C12B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49965 4.09097C7.51632 4.71597 7.34967 5.31598 7.04967 5.82432C6.88301 6.12432 6.66632 6.39933 6.40799 6.61599C5.84132 7.15766 5.08301 7.48266 4.24134 7.49932C3.20801 7.52432 2.27465 7.07432 1.66632 6.34932C1.54965 6.22432 1.44966 6.08266 1.35799 5.941C1.03299 5.44933 0.849655 4.86601 0.832988 4.24101C0.807988 3.19101 1.27465 2.23265 2.02465 1.60765C2.59132 1.14099 3.30797 0.849325 4.0913 0.832658C4.9663 0.815991 5.76633 1.13266 6.36633 1.66599C7.04133 2.25766 7.47465 3.11597 7.49965 4.09097Z",
    stroke: "#00C12B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86719 4.19198L3.70886 4.99194L5.4505 3.30859",
    stroke: "#00C12B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.8ddf983ee01403a40fe4ebeba079bc04.svg";
export { ForwardRef as ReactComponent };